Ext.define('SA.VectorMapFilterLayerProperties', {
    singleton: true,

    get({filter}) {
        if (!filter) {
            return {visible: false};
        }

        return {filter: SA.VectorMapFilterExpressions.not(SA.VectorMapFilterExpressions.fromFilter(filter)), visible: true};
    }
});